import React from "react";
import BottleRentForm from "./bottle-rent-form";
import BottleRentGrid from "./bottle-rent-grid";
import BottleRentToolbar from "./bottle-rent-toolbar";
import AuthorizedComponent from "../authorized-component";
import { ContentBlock } from "../../components";
import { BottleRentModel } from "../../models";
import { alertError, confirm2, enums, globalPopupManager, globalPopupNames, notifySuccess, prompt2 } from "../../base";
import { bottleRentService } from "../../api";

export default class BottleRentPage extends AuthorizedComponent {
    objectName = "BottleRent";
    gridRef = React.createRef<BottleRentGrid>();
    formRef = React.createRef<BottleRentForm>();
    toolbarRef = React.createRef<BottleRentToolbar>();

    constructor(props: any) {
        super(props);

        this.onModelSelected = this.onModelSelected.bind(this);
        this.onButtonClick = this.onButtonClick.bind(this);
        this.onSaved = this.onSaved.bind(this);
        this.filter = this.filter.bind(this);
    }

    onModelSelected(model: BottleRentModel) {
        this.toolbarRef.current?.setModel(model);
    }

    onButtonClick(model: BottleRentModel, name: string) {
        switch (name) {
            case "callcenter":
                globalPopupManager.show(globalPopupNames.callCenter, { id: model.customerId });
                break;

            case "add":
                if (this.permissions[enums.stdActions.create]) {
                    this.formRef.current?.show({ chargeTime: new Date() });
                }
                break;

            case "edit":
                if (this.permissions[enums.stdActions.update]) {
                    this.setNote(model);
                }
                break;

            case "delete":
                if (this.permissions[enums.stdActions.delete]) {
                    this.delete(model);
                }
                break;

            case "restore":
                if (this.permissions[enums.stdActions.delete]) {
                    this.restore(model);
                }
                break;
        }
    }

    filter(filterValue: any, showDeleted: boolean) {
        this.gridRef.current?.filter(filterValue, showDeleted);
    }

    async setNote(model: BottleRentModel) {
        const note = await prompt2("请输入备注：", { defaultValue: model.note || "" });
        
        if (note) {
            const res = await bottleRentService.setNote({ id: model.id!, note: note });
            if (res.succeeded) {
                notifySuccess("成功保存备注");
                this.onSaved();
            } else {
                alertError(res.message!);
            }
        }
    }

    async delete(model: BottleRentModel) {
        if (!await confirm2("确定要作废该条数据吗？")) {
            return;
        }

        const result = await bottleRentService.delete(model.id!);

        if (result.succeeded) {
            notifySuccess("已成功作废数据");
            this.gridRef.current?.refresh();
        } else {
            alertError(result.message!);
        }
    }

    async restore(model: BottleRentModel) {
        if (!await confirm2("确定要还原该条数据吗？")) {
            return;
        }

        const result = await bottleRentService.restore(model.id!);

        if (result.succeeded) {
            notifySuccess("已成功还原数据");
            this.gridRef.current?.refresh();
        } else {
            alertError(result.message!);
        }
    }

    onSaved() {
        this.gridRef.current?.refresh();
    }

    render() {
        return (
            <ContentBlock caption={"钢瓶使用费管理"}>
                <BottleRentToolbar
                    permissions={this.permissions}
                    ref={this.toolbarRef}
                    onFiltering={this.filter}
                    onButtonClick={this.onButtonClick} />
                <BottleRentGrid
                    ref={this.gridRef}
                    onModelSelected={this.onModelSelected}
                    onButtonClick={this.onButtonClick} />
                <BottleRentForm ref={this.formRef} onSaved={this.onSaved} />
            </ContentBlock>
        )
    }
}